import React, { useState } from 'react';
import {
    Table, Button, Card, Space, Form, Input, Select, Typography, Drawer,
    Segmented, Tooltip, Popconfirm, message
} from 'antd';
import { PlusOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { Title, Text, Link } = Typography;

const ROLE_OPTIONS = [
    { label: '平台视角', value: 'platform' },
    { label: '企业视角', value: 'enterprise' },
];

// mock 当前企业（企业视角）
const CURRENT_ENT = { name: '汇云科技', id: 'ENT-HUIYUN-01' };

// TODO: 联调时替换为接口数据
const POOL_DATA = [
    { id: 1, platformName: '麦联宝', entId: '0', entName: '鹤梦云平台', appKey: 'ak_mlb_9f21c7', secretKey: 'sk_mlb_3c9a02bb71', domain: 'https://api.mailianbao.com', cardCount: 1200, createTime: '2026-09-01 10:12:00' },
    { id: 2, platformName: '万物互联电信', entId: 'ENT-HUIYUN-01', entName: '汇云科技', appKey: 'ak_wwhl_77d0e4', secretKey: 'sk_wwhl_51be88fd20', domain: 'https://gw.wwhl-telecom.com', cardCount: 300, createTime: '2026-09-05 14:20:18' },
    { id: 3, platformName: '桔子智联', entId: 'ENT-HUIYUN-01', entName: '汇云科技', appKey: 'ak_jzzl_a1b2c3', secretKey: 'sk_jzzl_de7710aa63', domain: 'https://open.juzizhilian.cn', cardCount: 0, createTime: '2026-09-06 09:03:41' },
    { id: 4, platformName: '五兴科技', entId: 'ENT-XIAOHE-88', entName: '小鹤看家', appKey: 'ak_wxkj_5e6f70', secretKey: 'sk_wxkj_9081cc3fe1', domain: 'https://api.wuxing-iot.com', cardCount: 50, createTime: '2026-09-10 16:44:07' },
    { id: 5, platformName: '天贝云客猫', entId: 'ENT-TEST-099', entName: '产研测试验证企业', appKey: 'ak_tbykm_221ab9', secretKey: 'sk_tbykm_44cd90e11a', domain: 'https://open.tbykm.com', cardCount: 8, createTime: '2026-09-12 11:28:53' },
];

const PoolManage = () => {
    const [mockRole, setMockRole] = useState('platform');
    const [searchForm] = Form.useForm();
    const [form] = Form.useForm();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editing, setEditing] = useState(null);

    const isPlatform = mockRole === 'platform';
    const dataSource = isPlatform
        ? POOL_DATA
        : POOL_DATA.filter((d) => d.entId === CURRENT_ENT.id);

    const openCreate = () => {
        setEditing(null);
        form.resetFields();
        setDrawerOpen(true);
    };

    const openEdit = (record) => {
        setEditing(record);
        form.setFieldsValue(record);
        setDrawerOpen(true);
    };

    const handleSave = () => {
        form.validateFields().then(() => {
            message.success(editing ? '保存成功' : '新增成功');
            setDrawerOpen(false);
        });
    };

    const columns = [
        { title: '流量平台名称', dataIndex: 'platformName', key: 'platformName', width: 150 },
        ...(isPlatform
            ? [{
                title: '所属企业', key: 'ent', width: 200,
                render: (_, r) => (
                    <div>
                        <div>{r.entId === '0' ? '鹤梦云平台' : r.entName}</div>
                        <Text type="secondary" style={{ fontSize: 12 }}>企业ID：{r.entId}</Text>
                    </div>
                ),
            }]
            : []),
        { title: 'AppKey', dataIndex: 'appKey', key: 'appKey', width: 180 },
        { title: 'SecretKey', dataIndex: 'secretKey', key: 'secretKey', width: 190, render: (v) => <Text>{v}</Text> },
        { title: 'DomainName', dataIndex: 'domain', key: 'domain', width: 230 },
        {
            title: '已导卡数', dataIndex: 'cardCount', key: 'cardCount', width: 100,
            render: (v, r) => v > 0
                ? <Link onClick={() => message.info(`跳转流量卡管理，筛选流量池：${r.platformName}`)}>{v}</Link>
                : <Text type="secondary">0</Text>,
        },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 180 },
        {
            title: '操作', key: 'action', fixed: 'right', width: 120,
            render: (_, r) => (
                <Space size={0}>
                    <Button type="link" size="small" onClick={() => openEdit(r)}>编辑</Button>
                    <Tooltip title={r.cardCount > 0 ? '已导卡，不可删除' : ''}>
                        <Popconfirm
                            title="确认删除该流量池配置？"
                            disabled={r.cardCount > 0}
                            onConfirm={() => message.success('已删除')}
                        >
                            <Button type="link" size="small" danger disabled={r.cardCount > 0}>删除</Button>
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>流量池配置</Title>
                <Space size={8}>
                    <Text type="secondary" style={{ fontSize: 12 }}>mock 角色视角切换</Text>
                    <Segmented value={mockRole} onChange={setMockRole} options={ROLE_OPTIONS} />
                </Space>
            </div>

            <Card bordered={false} style={{ marginBottom: 16, borderRadius: 8 }}>
                <Form layout="inline" form={searchForm}>
                    <Form.Item name="platformName" style={{ marginBottom: 0 }}>
                        <Input placeholder="流量平台名称" allowClear style={{ width: 200 }} />
                    </Form.Item>
                    {isPlatform && (
                        <Form.Item name="ent" style={{ marginBottom: 0 }}>
                            <Input placeholder="企业ID / 名称" allowClear style={{ width: 200 }} />
                        </Form.Item>
                    )}
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={() => message.info('查询')}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={() => searchForm.resetFields()}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            <Card bordered={false} style={{ borderRadius: 8 }}>
                <div style={{ marginBottom: 16 }}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>新增流量池</Button>
                </div>
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    scroll={{ x: 1350 }}
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                />
            </Card>

            <Drawer
                title={editing ? '编辑流量池' : '新增流量池'}
                width={560}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                destroyOnClose
                footer={(
                    <div style={{ textAlign: 'right' }}>
                        <Button onClick={() => setDrawerOpen(false)} style={{ marginRight: 8 }}>取消</Button>
                        <Button type="primary" onClick={handleSave}>保存</Button>
                    </div>
                )}
            >
                <Form form={form} layout="vertical" initialValues={{ entId: '0' }}>
                    <Form.Item label="流量平台名称" name="platformName" rules={[{ required: true, message: '请输入流量平台名称' }]}>
                        <Input placeholder="请输入流量平台（卡商/运营商平台）名称" />
                    </Form.Item>
                    <Form.Item
                        label="所属企业"
                        name="entId"
                        rules={[{ required: true, message: '请选择所属企业' }]}
                        extra="企业ID=0 表示平台身份"
                    >
                        <Select
                            disabled={!isPlatform}
                            options={[
                                { label: '鹤梦云平台（ID=0）', value: '0' },
                                { label: '汇云科技（ENT-HUIYUN-01）', value: 'ENT-HUIYUN-01' },
                                { label: '小鹤看家（ENT-XIAOHE-88）', value: 'ENT-XIAOHE-88' },
                                { label: '产研测试验证企业（ENT-TEST-099）', value: 'ENT-TEST-099' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item label="AppKey" name="appKey" rules={[{ required: true, message: '请输入 AppKey' }]}>
                        <Input placeholder="请输入 AppKey" />
                    </Form.Item>
                    <Form.Item
                        label="SecretKey"
                        name="secretKey"
                        rules={[{ required: true, message: '请输入 SecretKey' }]}
                        extra="暂不加密，明文保存与展示"
                    >
                        <Input placeholder="请输入 SecretKey" />
                    </Form.Item>
                    <Form.Item label="DomainName" name="domain" rules={[{ required: true, message: '请输入 DomainName' }]}>
                        <Input placeholder="请输入接口域名，如 https://api.example.com" />
                    </Form.Item>
                </Form>
            </Drawer>
        </div>
    );
};

export default PoolManage;
